import { Pill } from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import {
  FilterItem,
  IntegerFilter as IntegerFilterType,
} from '../../../../services/types/services'
import { TopLevelFilterButton } from '../TopLevelFilterButton'

type Props = {
  filter: IntegerFilterType
  onClick: (filter: FilterItem) => void
}

export const IntegerFilter: FC<Props> = ({ filter, onClick }) => {
  const pill = filter.isNew ? <Pill label="New" /> : null

  return <TopLevelFilterButton filter={filter} onClick={onClick} pill={pill} />
}
